import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './pages/Layout';
import { HomeProducer } from './pages/HomeProducer';
import { HomeDistributor } from './pages/HomeDistributor';
import { RequireAuth } from './RequireAuth';
import { LoginProducer } from './pages/LoginProducer';
import { LoginDistributor } from './pages/LoginDistributor';
import { AddProduct } from './pages/AddProduct';
import { Profile } from './pages/Profile';
import { Security } from './pages/Security';
import { TermsAndCondition } from './pages/TermsAndCondition';
import { ProductSuccess } from './pages/ProductSuccess';
import { EditProductSuccess } from './pages/EditProductSuccess';
import { DeleteProductSuccess } from './pages/DeleteProductSuccess';

import { EditProduct } from './pages/EditProduct';
import { NoMatch } from './pages/NoMatch';
import { Welcome } from './pages/Welcome';
import './App.css';

function App() {
  return (
    <Authenticator.Provider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/signup-distributor" element={<LoginDistributor />} />
            <Route path="/signup-producer" element={<LoginProducer />} />
            <Route
              path="/home"
              element={
                <RequireAuth>
                  <div>Loading...</div>
                </RequireAuth>
              }
            />
            <Route
              path="/home/producer"
              element={
                <RequireAuth allowedRoles={['producer']}>
                  <HomeProducer />
                </RequireAuth>
              }
            />
            <Route
              path="/home/distributor"
              element={
                <RequireAuth allowedRoles={['distributor']}>
                  <HomeDistributor />
                </RequireAuth>
              }
            />
            <Route
              path="/security"
              element={
                <RequireAuth allowedRoles={['distributor', 'producer']}>
                  <Security />
                </RequireAuth>
              }
            />
            <Route
              path="/editproduct"
              element={
                <RequireAuth allowedRoles={['producer']}>
                  <EditProduct />
                </RequireAuth>
              }
            />
            <Route
              path="/profile"
              element={
                <RequireAuth>
                  <Profile />
                </RequireAuth>
              }
            />
            <Route
              path="/product-confirmation"
              element={
                <RequireAuth allowedRoles={['producer']}>
                  <ProductSuccess />
                </RequireAuth>
              }
            />
            <Route
              path="/edit-product-confirmation"
              element={
                <RequireAuth allowedRoles={['producer']}>
                  <EditProductSuccess />
                </RequireAuth>
              }
            />
            <Route
              path="/delete-product-confirmation"
              element={
                <RequireAuth allowedRoles={['producer']}>
                  <DeleteProductSuccess />
                </RequireAuth>
              }
            />
            <Route
              path="/terms-and-condition"
              element={<TermsAndCondition />}
            />
            <Route
              path="*"
              element={
                <RequireAuth allowedRoles={['distributor', 'producer']}>
                  <NoMatch />
                </RequireAuth>
              }
            />
            <Route
              path="/addproduct"
              element={
                <RequireAuth allowedRoles={['producer']}>
                  <AddProduct />
                </RequireAuth>
              }
            />
            <Route
              path="/welcome"
              element={
                <RequireAuth>
                  <Welcome />
                </RequireAuth>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </Authenticator.Provider>
  );
}

export default App;
